<template>
  <header @mouseleave="hideExtendedMenu" class="app-header no-print" :class="{'transparent-nav': isTransparentNav}">
    <modal-login :shown="modal==='login'" @close="hideModal" :recovery="isRecoveryMode" />
    <modal-register :shown="modal==='register'" @close="hideModal" />
    <modal-details :shown="modal==='details'" @close="hideModal" />
    <modal-subscriber-details :shown="modal==='subscriber-details'" @close="hideModal" />
    <notifications-dashboard v-if="settingsModal === 'notifications'" />

    <cookie-law></cookie-law>
    <div v-if="isMobileMenuOpen" class="mobile-nav-mask" @click="closeMobileMenu"></div>
    <transition name="slide" mode="out-in">
      <mobile-nav v-if="isMobileMenuOpen" @hide="closeMobileMenu"></mobile-nav>
    </transition>

    <div class="header-wrap">
      <div class="header-top">
        <div class="item-left">
          <router-link to="/" class="logo">
            <img class="logo-image" src="/assets/images/logos/generic_deal_logo.svg" title="Africa Dealroom" alt="Africa Dealroom Logo">
          </router-link>
        </div>
        <div class="item-right">
          <account-menu />
          <div class="mobile-controls">
            <a @click="openMobileMenu" aria-label="menu">
              <menu-icon />
            </a>
          </div>
        </div>
      </div>

      <div v-if="!isMinHeader" class="header-bottom">


        <div class="item-block">
          <router-link to="/"
            @click.native="hideExtendedMenu"
            @mouseover.native="showExtendedMenu('tdb-dealroom-menu')"
            :class="{opened: extended==='tdb-dealroom-menu'}"
            aria-label="TDB Deal Room">
            <span>TDB Deal Room</span>
            <chevron-up />
          </router-link>
          <p class="item-caption">Great funding opportunities for African businesses</p>
          <tdb-dealroom-menu
            v-if="extended === 'tdb-dealroom-menu'"
            class="extended-menu tdb-dealroom-menu"
            @hide="hideExtendedMenu"
            v-on-clickaway="hideExtendedMenu"
          />
        </div>
  </div>
    </div>
  </header>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { mixin as clickaway } from 'vue-clickaway'
import CookieLaw from 'components/cookie-law'
import AccountMenu from 'components/user-menu/account-menu'
import TdbDealroomMenu from 'theme/layout/menu/tdb-dealroom-menu'
import MobileNav from 'components/home/mobile-nav-new'
import modalLogin from 'components/modals/modal-login.vue'
import modalRegister from 'components/modals/modal-register.vue'
import modalDetails from 'components/modals/modal-details.vue'
import modalSubscriberDetails from 'components/modals/modal-subscriber-details.vue'
import NotificationsDashboard from 'components/projects/notifications/notifications-dashboard.vue'
import menuIcon from 'assets/images/icons/menu-icon.svg?inline'
import chevronUp from 'assets/images/icons/chevron-up.svg?inline'

export default {
  name: 'app-header',
  components: {
    CookieLaw,
    AccountMenu,
    MobileNav,
    TdbDealroomMenu,
    modalLogin,
    modalRegister,
    modalDetails,
    modalSubscriberDetails,
    NotificationsDashboard,
    menuIcon,
    chevronUp,
  },
  mixins: [clickaway],
  data() {
    return {
      extended: '',
      isTopScrolled: true,
      isMobileMenuOpen: false,
    }
  },
  computed: {
    ...mapState({
      modal: state => state.modals.currentModal,
    }),
    isMinHeader() {
      return this.$route.meta.minheader
    },
    settingsModal() {
      return this.$store.getters['settings/settingsModal']
    },
    isDealbookEnabled() {
      return this.$store.getters.isDealbookEnabled
    },
    isMarketInsightEnabled() {
      return this.$store.getters.isMarketInsightEnabled
    },
    isDealHistoryEnabled() {
      return this.$store.getters.isDealHistoryEnabled
    },
    isDITEnabled() {
      return this.$store.getters.isDITEnabled
    },
    isWATIHEnabled() {
      return this.$store.getters.isWATIHEnabled
    },
    isTransparentNav() {
      return this.$route.path === '/' && this.isTopScrolled
    },
    userId() {
      return this.$store.state.user.currentUser.userId || 'guest'
    },
    modalData() {
      return this.$store.getters.modalData
    },
    isRecoveryMode() {
      if (this.modalData && this.modalData.mode === 'recovery') {
        return true
      }
      return false
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleTopScroll)
  },
  methods: {
    ...mapActions({
      showModal: 'showModal',
      hideModal: 'hideModal',
    }),
    showExtendedMenu(title) {
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'show-section-menu ' + title,
        eventLabel: 'UserID ' + this.userId,
      })
      this.$gtag.event('show-section-menu ' + title, {
        'event_category': 'Click',
        'event_label': 'UserID ' + this.userId,
      })
      this.extended = title
    },
    hideExtendedMenu() {
      this.extended = ''
    },
    handleTopScroll() {
      if (this.$route.name !== 'Home') {
        return
      }
      const position =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0
      if (position === 0) {
        this.isTopScrolled = true
      } else {
        this.isTopScrolled = false
      }
    },
    openMobileMenu() {
      this.isMobileMenuOpen = true
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false
    },
  },
  watch: {
    $route(to, from) {
      if (this.isMobileMenuOpen) {
        this.closeMobileMenu()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.app-header {
  position: fixed;
  top: 0px;
  width: 100%;
  z-index: 10000;
  a {
    cursor: pointer;
  }
}
.header-top {
  display: flex;
  justify-content: space-between;
  background: $header-bg;
  .item-left {
    padding: $padding-m $padding-l;
    .logo-image {
      height: 35px;
    }
    .logo:hover .logo-image {
      opacity: 0.7;
    }
  }
  .item-right {
    display: flex;
    align-items: center;
    padding-right: $padding-l;
  }
}
.header-bottom {
  display: none;
  @include desktop {
    display: flex;
    justify-content: space-between;
    box-shadow: $bottom-only-shadow;
  }
  background: $header-bg;
  padding-left: $padding-m;
  .item-block {
    padding: 0px $padding-m;
    position: relative;
  }
  .item-caption {
    font-size: 12px;
    color: #777e85;
    margin-top: $margin-s;
    max-width: 300px;
  }
  a {
    white-space: nowrap;
    color: #002560;
    font-weight: 500;
    margin-right: $margin-m;
    border-top: 3px solid transparent;
    border-bottom: 2px solid #002560;
    &:hover {
      color: lighten(#002560, 25%);
      border-bottom-color: $primary-accent-color;
    }
    @include desktop {
      margin-right: $margin-l;
    }
  }
  .opened {
    border-bottom-color: $primary-accent-color;
  }
}
.transparent-nav {
  box-shadow: unset;
  .header-top,
  .header-bottom {
    background: transparent;
  }
  .header-bottom {
    box-shadow: unset;
  }
  .extended-menu {
    box-shadow: $bottom-shadow;
  }
}

.extended-menu {
  display: none;
  @include desktop {
    display: inline-flex;
  }
  background: #fff;
  border-top: 1px solid #eee;
  box-shadow: $bottom-shadow;
  z-index: 1000;
}
.solutions-menu {
  position: absolute;
  top: 25px;
  left: 0px;
}
.opportunities-menu {
  position: absolute;
  top: 25px;
  left: -20px;
}
.deals-menu {
  position: absolute;
  top: 25px;
  left: -150px;
}
.funding-menu {
  position: absolute;
  top: 25px;
  left: -200px;
}
.about-menu {
  position: absolute;
  top: 25px;
  right: 20px;
}

.mobile-nav-mask {
  position: fixed;
  z-index: 8995;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $mask-bg;
  display: table;
  transition: opacity 0.1s ease;
}
.slide-enter-active,
.slide-leave-active,
.slide-bottom-active,
.slide-bottom-leave-active {
  transition: all 0.1s linear;
}
.slide-enter,
.slide-leave-to {
  transform: translateX(300px);
}
.slide-bottom-enter,
.slide-bottom-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
.mobile-controls {
  display: inline-flex;
  align-items: center;
  margin-left: $margin-m;
  a {
    display: inline-flex;
  }
  svg {
    @extend %icon-std;
  }
  @include desktop {
    display: none;
  }
}
</style>
